import { render, staticRenderFns } from "./MyScore.vue?vue&type=template&id=40eaa4fa&scoped=true&"
import script from "./MyScore.vue?vue&type=script&lang=js&"
export * from "./MyScore.vue?vue&type=script&lang=js&"
import style0 from "./MyScore.vue?vue&type=style&index=0&id=40eaa4fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eaa4fa",
  null
  
)

export default component.exports